import { useQuery } from '@tanstack/react-query';
import { listMyModulesOptions } from '../generated/api/@tanstack/react-query.gen.js';

// Fetches modules enabled for the authenticated user's org. Cached via React
// Query; invalidate with `queryClient.invalidateQueries({ queryKey: listMyModulesQueryKey() })`
// when an org admin toggles a module.
export function useEnabledModules() {
  const query = useQuery({
    ...listMyModulesOptions(),
    select: (res) => res.data,
    staleTime: 5 * 60 * 1000,
  });
  if (query.isError) console.error('useEnabledModules: failed to load enabled modules', query.error);
  return query;
}

// Returns whether a specific module is enabled for the current user's org.
// Returns `undefined` while the modules list is still loading — callers that
// must gate side effects (e.g., `useQuery({ enabled: isEnabled })`) should
// treat `undefined` as "not yet, don't fetch".
export function useIsModuleEnabled(moduleId: string): boolean | undefined {
  const { data, isLoading } = useEnabledModules();
  if (isLoading) return undefined;
  return data?.some((m) => m.id === moduleId) ?? false;
}
